import { render } from "./Requests.vue?vue&type=template&id=109f2c63&scoped=true"
import script from "./Requests.vue?vue&type=script&lang=js"
export * from "./Requests.vue?vue&type=script&lang=js"

import "./Requests.vue?vue&type=style&index=0&id=109f2c63&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-109f2c63"

export default script